import bank from './bank/bank.reducer'
import company from '../company/company.reducer'
const entitiesReducers = {
    bank,
    company
  };
  
  export default entitiesReducers;